<template>
  <v-dialog v-model="dialog" width="720px" scrollable="false">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon color="#F20732">mdi-window-close</v-icon>
      </v-btn>
    </template>

    <v-card class="deleteModalCard" flat style="height: 283px;">
      <v-card-title class="d-flex align-center justify-space-between" style="height: 25%;">
        <div class="d-flex align-center">
          <v-img
            :src="require(`@/assets/icons/red-user-minus.png`)"
            height="48"
            width="48"
            class="mr-4"
          />
          <span class="modalTitle">Deseja deletar esse administrador?</span>
        </div>
        <v-btn icon text @click="dialog = false">
          <Icon icon="mdi-close" color="#9E9E9E" size="24" style="cursor: pointer;" />
        </v-btn>
      </v-card-title>
      <v-card-text class="d-flex align-center justify-center" style="height: 50%">
        <p
          class="my-5 mx-3 modalText"
        >Se você confirmar esta ação não poderá voltar. Você realmente deseja confirmar essa ação?</p>
      </v-card-text>
      <v-card-actions style="height: 25%;">
        <v-btn class="cancelButton mb-10 ml-5" text @click="dialog = false">
          <span class="buttonTextBlue">Cancelar</span>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="#B7000C" class="confirmButton mb-10 mr-5" @click="deleteAdmin">
          <span class="buttonTextWhite">Confirmar</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import axios from "axios";
import Icon from "@/components/atoms/icon";

export default {
  components: {
    Icon
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    deleteAdmin() {
      axios
        .delete(`${process.env.VUE_APP_API_URL}/api/admin/remove`, {
          headers: { Authorization: `Bearer ${this.$store.state.user.token}` },
          data: { _id: this.id }
        })
        .then(
          axios
            .get(`${process.env.VUE_APP_API_URL}/api/admin/webapp`, {
              headers: {
                Authorization: `Bearer ${this.$store.state.user.token}`
              }
            })
            .then(res => {
              this.$store.dispatch("setAccounts", {
                accounts: res.data.data.users
              });
            })
        )
        .catch(err => console.log(err));
      this.dialog = false;
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.deleteModalCard {
  height: 283px;
  background: #ffffff;
  border-radius: 10px;
}

.cancelButton {
  height: 40px;
  width: 203px;
  border-radius: 5px;
  box-sizing: border-box;
}

.confirmButton {
  height: 40px;
  width: 203px;
  border-radius: 5px;
  box-sizing: border-box;
}

.buttonTextBlue {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
}

.buttonTextWhite {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #fff;
}

.modalTitle {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.5px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}

.modalText {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}
</style>